import { IStore } from '@/interfaces/store/store.interface';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { state } from './state';
import { readonly } from 'vue';
import { IState } from '@/interfaces/store/state.interface';

const store: IStore = {
	state: readonly(state) as IState,
	actions,
	getters,
	mutations,
};

export { store };
